export default __webpack_public_path__ + "static/media/meal.1b33a8e9.svg";